export default class Scenario {
  constructor(scenarioName, vendor, dealName) {
    this.ScenarioName = scenarioName;
    this.Vendor       = vendor;
    this.DealName     = dealName;
    this.Cpr          = [];
    this.Cdr          = [];
    this.LossSeverity = [];
    this.Delinquency  = [];
    this.isNew        = true;
    this.Shared       = false;
  }
}
